import { TextField, Typography } from "@mui/material";
import { Box, Grid } from "@mui/material";
import axios from "axios";

import { ChangeEvent, useEffect, useState } from "react";
import { useSnackbar } from "../context/SnackbarContext";
import { editProfileApi } from "../api/profile";
// import { useNavigate } from "react-router-dom";

const ProfileSettings = () => {
  const [reset, setReset] = useState(false);

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [Loading, setLoading] = useState<boolean>(false);
  const { showSnackbar } = useSnackbar();

  console.log(Loading);

  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [validPassword, setValidPassword] = useState(true);

  useEffect(() => {
    setPasswordsMatch(true);
    setValidPassword(true);
  }, []);

  const localFirstname = localStorage.getItem("firstname");
  // const lastname = localStorage.getItem("lastname");
  const localCompanyName = localStorage.getItem("companyName");
  const localEmail = localStorage.getItem("email");

  const handleReset = async (e: any, newPassword: string) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!newPassword) {
        showSnackbar("Please enter a new password", "error");
        return;
      }

      if (!confirmPassword) {
        showSnackbar("Please confirm the new password", "error");
        return;
      }

      if (newPassword !== confirmPassword) {
        showSnackbar("Passwords do not match", "error");
        return;
      }

      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
      if (!passwordRegex.test(newPassword)) {
        showSnackbar(
          "Password must contain at least one uppercase letter, one lowercase letter, one number, and be at least 8 characters long",
          "error"
        );
        return;
      }
      const email = "suhail@veehive.ai";
      const otp = 1234;

      const response = await axios.post(
        `${import.meta.env.VITE_BASE_URL}/clients/user/reset-password`,
        { email: email, newPassword: newPassword, otp: otp }
      );

      if (response.data.statusCode === "OK") {
        setNewPassword(newPassword);
        showSnackbar(response.data.responseInfo.description, "success");
      } else {
        showSnackbar(response.data.responseInfo.description, "error");
        setNewPassword("");
        setConfirmPassword("");
      }
    } catch (error) {
      console.error("Error during password reset:", error);
    } finally {
      setLoading(false);
    }
  };

  const forgetPassword = async () => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_BASE_URL}/clients/user/forget-password`,
        {
          email: email,
        }
      );

      if (response.data.statusCode === "OK") {
        showSnackbar(response.data.responseInfo?.description, "success");
      } else {
        showSnackbar(response.data.responseInfo?.description, "error");
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
    }
  };

  const resetPassword = () => {
    setReset(true);
    forgetPassword();
  };

  const [companyName, setCompanyName] = useState(localCompanyName);

  // const [companyNameChanged, setCompanyNameChanged] = useState(false);

  const email = localEmail;
  const [firstName, setFirstName] = useState(localFirstname);

  const [firstNameChanged, setFirstNameChanged] = useState(false);

  const handleFirstNameChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFirstNameChanged(true);
    setFirstName(e.target.value.slice(0, 100));
  };

  useEffect(() => {
    setCompanyName(localCompanyName);
  }, [localCompanyName]);

  const onFirstNameClicked = () => {
    setFirstNameChanged(false);
    editProfileApi(firstName || "");
  };

  // const handleCompanyChange = (e: ChangeEvent<HTMLInputElement>) => {
  //   setCompanyNameChanged(true);
  //   setCompanyName(e.target.value.slice(0, 100));
  // };

  // const onCompanySaveClicked = () => {
  //   setCompanyNameChanged(false);
  //   companyName && saveCompanyName(setLoading, companyName);
  // };

  return (
    <>
      <Box sx={{ padding: "20px", position: "relative", height: "100%" }}>
        <Grid>
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}
          >
            User Name
          </Typography>
        </Grid>
        <Grid>
          <div className="profile_change_details_wrapper">
            <TextField
              fullWidth
              size="small"
              placeholder="UserName"
              sx={{ fontSize: "14px" }}
              value={`${firstName}`}
              onChange={handleFirstNameChange}
            />
            {firstNameChanged && (
              <p
                onClick={onFirstNameClicked}
                className="fs12 save_ak_profile_details"
              >
                Save
              </p>
            )}
          </div>
        </Grid>

        <Grid sx={{ mt: "3%" }}>
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: "14px", fontWeight: "bold" }}
          >
            Email
          </Typography>
        </Grid>
        <Grid>
          <p>{email}</p>
          {/* <TextField
            fullWidth
            size="small"
            placeholder="Email"
            sx={{ fontSize: "14px" }}
            value={email}
            onChange={handleEmailChange}
          /> */}
        </Grid>

        <Grid sx={{ mt: "3%" }}>
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: "14px", fontWeight: "bold" }}
          >
            Company Name
          </Typography>
        </Grid>
        <Grid>
          <div className="profile_change_details_wrapper">
            <p>{companyName}</p>
          </div>
        </Grid>

        <Typography
          sx={{
            marginY: "15px",
            color: "#0181C8",
            cursor: "pointer",
            fontSize: "14px",
          }}
          fontWeight="550"
          onClick={resetPassword}
        >
          Reset Password
        </Typography>

        {reset && (
          <>
            {/* ... (existing code) ... */}
            <Grid sx={{ mt: "3%" }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}>
                Enter OTP
              </Typography>
            </Grid>
            <Grid>
              <TextField
                fullWidth
                size="small"
                placeholder="Enter OTP"
                sx={{ fontSize: "14px" }}
                type="password"
                // value={newPassword}
                // onChange={(e) => setNewPassword(e.target.value)}
              />
            </Grid>
            <Grid sx={{ mt: "3%" }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}>
                New Password
              </Typography>
            </Grid>
            <Grid>
              <TextField
                fullWidth
                size="small"
                placeholder="New Password"
                sx={{ fontSize: "14px" }}
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </Grid>
            <Grid sx={{ mt: "3%" }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}>
                Confirm Password
              </Typography>
            </Grid>
            <Grid>
              <TextField
                fullWidth
                size="small"
                placeholder="Confirm Password"
                sx={{ fontSize: "14px", mb: "3%" }}
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              {!passwordsMatch && (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  Passwords do not match.
                </Typography>
              )}
              {!validPassword && (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  Password must be at least 8 characters long and contain at
                  least one number and one special character.
                </Typography>
              )}
            </Grid>
            {!passwordsMatch && (
              <Typography sx={{ color: "red", fontSize: "12px", mt: "3%" }}>
                New Password and Confirm Password must match.
              </Typography>
            )}
            <button
              className="create-job"
              style={{ marginLeft: "0px" }}
              onClick={(e) => handleReset(e, newPassword)}
            >
              Save
            </button>
          </>
        )}
      </Box>
    </>
  );
};

export default ProfileSettings;
